import axios from "../../axios";

const urlTeam = "/users";
const urlTeamDeleteMultiple = "/users/delete-multiple";

const state = {
  teams: [],
  pagination: {
    current_page: 1,
    per_page: 10,
    total: 0,
  },
};

const actions = {
  /**
   * getListTeams
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getListTeams({ commit }, query) {
    const response = await axios.get(
      `${urlTeam}?${new URLSearchParams(query)}`,
    );
    if (response.status === 200) {
      commit("SET_LIST_TEAMS", response.data.data);
    }

    return response;
  },

  /**
   * createTeam
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  // eslint-disable-next-line no-unused-vars
  async createTeam({ commit }, payload) {
    const bodyFormData = new FormData();
    for (const key in payload) {
      bodyFormData.append(key, payload[key]);
    }
    return await axios.post(urlTeam, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  /**
   * updateTeam
   * @param commit
   * @param id
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  // eslint-disable-next-line no-unused-vars
  async updateTeam({ commit }, { id, payload }) {
    const bodyFormData = new FormData();
    for (const key in payload) {
      bodyFormData.append(key, payload[key]);
    }
    return await axios.post(`${urlTeam}/${id}?_method=PUT`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  /**
   * deleteTeam
   * @param commit
   * @param id
   * @returns {Promise<AxiosResponse<any>>}
   */
  // eslint-disable-next-line no-unused-vars
  async deleteTeam({ commit }, id) {
    return await axios.delete(`${urlTeam}/${id}`);
  },

  /**
   * deleteMultiple
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  // eslint-disable-next-line no-unused-vars
  async deleteMultiple({ commit }, payload) {
    return await axios.post(urlTeamDeleteMultiple, payload);
  },

  /**
   * set current page
   * @param commit
   * @param data
   */
  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },
};

const mutations = {
  SET_LIST_TEAMS(state, data) {
    if (data) {
      state.teams = data.items;
      state.pagination = data.pagination;
    }
  },
  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
